var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#17A1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84473 10.75C4.43051 10.75 4.09473 10.4142 4.09473 10C4.09473 9.58579 4.43051 9.25 4.84473 9.25V10.75ZM16.6888 9.46967C16.9817 9.76256 16.9817 10.2374 16.6888 10.5303L11.9158 15.3033C11.6229 15.5962 11.148 15.5962 10.8551 15.3033C10.5622 15.0104 10.5622 14.5355 10.8551 14.2426L15.0978 10L10.8551 5.75736C10.5622 5.46447 10.5622 4.98959 10.8551 4.6967C11.148 4.40381 11.6229 4.40381 11.9158 4.6967L16.6888 9.46967ZM4.84473 9.25L16.1584 9.25V10.75L4.84473 10.75V9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveProduct);
export default __webpack_public_path__ + "static/media/move-product.0c2668e399b2da94001b8276f16671fd.svg";
export { ForwardRef as ReactComponent };